// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root_rrK04 {\n  height: 100%;\n  margin-top: 5px;\n  margin-left: 10px;\n  margin-right: 10px;\n}", "",{"version":3,"sources":["webpack://./components/RequestTabs/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AACJ","sourcesContent":[".root {\r\n    height: 100%;\r\n    margin-top: 5px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "root_rrK04"
};
export default ___CSS_LOADER_EXPORT___;
